import type { QueryKey } from "@tanstack/react-query";

export const casePathologistAssignmentQueryKeys = {
  context: (caseId: string) =>
    ["case-pathologist-assignment-context", caseId] as const,
  history: (caseId: string) =>
    ["case-pathologist-assignment-history", caseId] as const,
  latestHistory: (caseId: string) =>
    ["case-pathologist-assignment-history", caseId, "latest"] as const,
  notices: ["pathologist-assignment-notices"] as const,
  caseDetail: (caseId: string) => ["case", caseId] as const,
  caseLists: ["cases"] as const,
  pathologistReviewQueues: ["pathologist-review-queue"] as const,
  pathologistIncomingQueues: ["pathologist-incoming-queue"] as const,
  pendingDistributionQueues: ["pending-distribution"] as const,
};

export interface AssignmentInvalidationTarget {
  exact: boolean;
  queryKey: QueryKey;
}

const sharedListTargets: AssignmentInvalidationTarget[] = [
  { queryKey: casePathologistAssignmentQueryKeys.caseLists, exact: false },
  {
    queryKey: casePathologistAssignmentQueryKeys.pathologistReviewQueues,
    exact: false,
  },
  {
    queryKey: casePathologistAssignmentQueryKeys.pathologistIncomingQueues,
    exact: false,
  },
  {
    queryKey: casePathologistAssignmentQueryKeys.pendingDistributionQueues,
    exact: false,
  },
];

export function assignmentChangeInvalidationTargets(
  caseId: string
): AssignmentInvalidationTarget[] {
  return [
    {
      queryKey: casePathologistAssignmentQueryKeys.context(caseId),
      exact: true,
    },
    {
      queryKey: casePathologistAssignmentQueryKeys.history(caseId),
      exact: true,
    },
    ...assignmentNoticeInvalidationTargets([caseId]),
  ];
}

export function assignmentNoticeInvalidationTargets(
  caseIds: string[]
): AssignmentInvalidationTarget[] {
  const uniqueCaseIds = Array.from(new Set(caseIds));
  return [
    ...uniqueCaseIds.map((caseId) => ({
      queryKey: casePathologistAssignmentQueryKeys.caseDetail(caseId),
      exact: true,
    })),
    ...sharedListTargets,
  ];
}
